// ============================================================================
// File: components/alerts/AlertsPanel.jsx
// Purpose: Enterprise Alert Banner
// ============================================================================

import React from "react";

export default function AlertsPanel({ alerts }) {

  if (!alerts || alerts.length === 0) return null;

  const getClass = (severity) => {
    switch (severity) {
      case "HIGH":
        return "alert-high";
      case "MEDIUM":
        return "alert-medium";
      default:
        return "alert-low";
    }
  };

  return (
    <div className="alerts-container">

      {alerts.map((alert, index) => (
        <div
          key={index}
          className={`alert-banner ${getClass(alert.severity)}`}
        >
          <span className="alert-icon">⚠</span>
          <span className="alert-text">{alert.message}</span>
        </div>
      ))}

    </div>
  );
}
